import { ProductImpressionTrackingInfo } from "@omni/types/components/tracking/tracking-info/impression/productImpression.trackingInfo";

import { TypedAnalyticsEvent } from "@/services/tracking/types/analyticsEvent";

import { GoogleAnalyticsEvents } from "../GoogleAnalyticsEvents";
import {
    GoogleAnalyticsMinimumDataset,
    getPageInfo,
    getUserInfo
} from "../GoogleAnalyticsMinimumDataset";
import {
    GoogleAnalyticsProduct,
    getGoogleAnalyticsProduct
} from "./GoogleAnalyticsProduct";

export interface GoogleAnalyticsAddToWishlistImpression
    extends GoogleAnalyticsMinimumDataset {
    ecommerce: {
        click: {
            products: GoogleAnalyticsProduct[];
        };
    };
}

const getGoogleAnalyticsAddToWishlistImpression = (
    data: TypedAnalyticsEvent<ProductImpressionTrackingInfo>
): GoogleAnalyticsAddToWishlistImpression => {
    const googleAnalyticsCommerce: GoogleAnalyticsProduct =
        getGoogleAnalyticsProduct(data.payload.eventData);

    return {
        event: GoogleAnalyticsEvents.ProductAddToWishlist,
        pageInfo: getPageInfo(data),
        userInfo: getUserInfo(data),
        ecommerce: {
            click: {
                products: [
                    {
                        ...googleAnalyticsCommerce
                    }
                ]
            }
        }
    };
};

export { getGoogleAnalyticsAddToWishlistImpression };
